import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=36f767f3&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=36f767f3&prod&scoped=true&lang=scss"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=36f767f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f767f3",
  null
  
)

export default component.exports